/**
 * useSiteBrand — the accent colour and crest set in Admin → Site Appearance.
 *
 * Reads the same `app-config` cache the whole app already holds, so this costs
 * nothing extra. `AppConfigProvider` also writes the accent onto `:root`
 * (`--fwm-accent` and friends); this hook is for the few pages that need the
 * value in JavaScript.
 */
import { useQuery } from '@tanstack/react-query';
import api from '@/lib/api';

export const useSiteBrand = () => {
  const { data } = useQuery({
    queryKey: ['app-config'],
    queryFn: async () => (await api.get('/app-config')).data,
    staleTime: 60000 * 5,
  });
  return {
    accent: data?.accent_color || '',
    accentDark: data?.accent_dark || '',
    accentSoft: data?.accent_soft || '',
    accentInk: data?.accent_ink || '',
    logoUrl: data?.logo_url || '',
  };
};

export default useSiteBrand;
